import React from 'react';
import { Phone, MessageCircle, MapPin, Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ContactCTA = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello! I would like to get a quote for AC services.");
    window.open(`https://wa.me/97474408801?text=${message}`, '_blank');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Contact us today for professional AC services across Qatar. 
            We're here to help 24/7 with all your cooling needs.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {/* Phone */}
          <a
            href="tel:+97470086090"
            className="group bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center"
          >
            <div className="bg-blue-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Phone size={24} className="text-white" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Call Us Now</h3>
            <p className="text-blue-600 font-semibold mb-1">+974 7008 6090</p>
            <p className="text-gray-600 text-sm">24/7 Emergency Line</p>
          </a>

          {/* WhatsApp */}
          <button
            onClick={handleWhatsAppClick}
            className="group bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center w-full"
          >
            <div className="bg-green-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <MessageCircle size={24} className="text-white" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">WhatsApp</h3>
            <p className="text-green-600 font-semibold mb-1">Quick Response</p>
            <p className="text-gray-600 text-sm">Instant messaging</p>
          </button>

          {/* Location */}
          <div className="group bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center">
            <div className="bg-purple-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <MapPin size={24} className="text-white" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Visit Us</h3>
            <p className="text-purple-600 font-semibold mb-1">Muaither, Doha</p>
            <p className="text-gray-600 text-sm">Qatar Location</p>
          </div>

          {/* Hours */}
          <div className="group bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center">
            <div className="bg-orange-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Clock size={24} className="text-white" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Working Hours</h3>
            <p className="text-orange-600 font-semibold mb-1">24/7 Available</p>
            <p className="text-gray-600 text-sm">Emergency Service</p>
          </div>
        </div>

        {/* Main CTA */}
        <div className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl p-12 text-center text-white shadow-2xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Need Emergency AC Service?
          </h3>
          <p className="text-lg mb-8 opacity-90">
            Our certified technicians are available 24/7 for emergency repairs and installations
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:+97470086090"
              className="bg-white text-purple-600 px-8 py-4 rounded-xl text-lg font-bold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 flex items-center space-x-2 shadow-lg"
            >
              <Phone size={20} />
              <span>Emergency Call</span>
            </a>
            
            <Link
              to="/contact"
              className="bg-purple-700 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-purple-800 transition-all duration-300 transform hover:scale-105 flex items-center space-x-2 shadow-lg border-2 border-white/20"
            >
              <span>Get Free Quote</span>
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;